import { Box } from "@mui/material";

import { styled } from "@mui/material/styles";
import { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { Row } from "@tanstack/table-core";

const PillCell = styled("div")({
  display: "flex",
  justifyContent: "flex-start",
});

const TextCenter = styled("div")(({ theme }) => ({
  fontSize: 14,
  color: theme.vars.palette.text.primary,
  margin: 0,
  padding: 0,
  textAlign: "center",
}));

const Chip = styled("div")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "2px",
  borderRadius: 999,
  padding: "2px 8px",
  color: theme.vars.palette.text.primary,
  ...theme.typography.bodyMicroRegular,
}));

const ChipOnline = styled(Chip)(({ theme }) => ({
  background: theme.vars.palette.backgrounds.success.moderate.default,
  color: theme.vars.palette.texts.success.default,
}));

const ChipOffline = styled(Chip)(({ theme }) => ({
  background: theme.vars.palette.backgrounds.danger.moderate.default,
  color: theme.vars.palette.texts.danger.default,
}));

export function DeviceStatus<T extends { deviceStatus: boolean | null }>(
  cell: CellContext<T, boolean | null>,
) {
  const { t } = useTranslation();

  const deviceStatus = cell.getValue();

  return (
    <PillCell>
      {deviceStatus === null && <TextCenter>-</TextCenter>}
      {deviceStatus === false && <ChipOffline>{t("offline")}</ChipOffline>}
      {deviceStatus === true && <ChipOnline>{t("online")}</ChipOnline>}
      <Box sx={{ width: "24px", visibility: "hidden" }} />
    </PillCell>
  );
}

export function deviceStatusSort<T extends { deviceStatus: boolean | null }>(
  rowA: Row<T>,
  rowB: Row<T>,
) {
  const rank = [true, false, null];

  return (
    rank.indexOf(rowA.original.deviceStatus) -
    rank.indexOf(rowB.original.deviceStatus)
  );
}

export function Sex<T extends { sex: string | null }>(
  cell: CellContext<T, string | null>,
) {
  const { t } = useTranslation();

  const gender = cell.getValue();

  if (gender === "male") return <>{t("Male")}</>;
  if (gender === "female") return <>{t("Female")}</>;

  return <>-</>;
}
